import { AuthenticationService } from '../../_guards/auth.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ServicesData } from 'src/app/services/services.data';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DashboardLocatorDataService } from './dashboard-locator.data';
import { ChartOptions } from 'chart.js';
import { DateRangeClass } from 'src/app/components/dateInput-range/date-input-range.class';
import { DateInputRange } from 'src/app/components/dateInput-range/date-input-range.cmp';

@Component({
  templateUrl: './dashboard-locator.tmpl.html',
  styleUrls: ['./dashboard-locator.scss']
})
export class DashboardLocatorComponent implements OnInit {
  model: any;
  centeralForm: FormGroup;
  centeralDataObj: any = {};
  subjectCommitmentReasons: [];

  // Chart properties
  pieChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        align: 'start',
        rtl: true,
        textDirection: 'rtl',
        labels: {
          textAlign: 'right'
        }
      }
    }
  };
  pieChartLabels: any[];
  pieChartDatasets: any[];
  pieChartLegend = true;
  pieChartPlugins = [];

  lineChartOptions = { responsive: true, maintainAspectRatio: false };
  lineChartLabels: any[];
  lineChartDatasets: any[];

  amountsLineChartOptions = { responsive: true, maintainAspectRatio: false };
  amountsLineChartLabels: any[];
  amountsLineChartDatasets: any[];

  lineChartLegend = true;
  lineChartPlugins = [];

  @ViewChild('releventDateRangeCom') releventDateRangeCom: DateInputRange;

  constructor(
    public servicesData: ServicesData,
    private authService: AuthenticationService,
    private dashboardLocatorDataService: DashboardLocatorDataService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    if (this.authService.isAuthorized("SystemAdministrator,dashboardLocator")) {
      this.dashboardLocatorDataService.get().subscribe(db => {
        this.model = db;
      });
      this.initCenteralForm();
      this.loadCenteralData();
    }
  }

  loadCenteralData() {
    this.dashboardLocatorDataService.centeralData(this.centeralForm.value).subscribe((x: any) => {
      this.centeralDataObj = x;
      this.pieChartLabels = x.donationDetailsGroup.map((y: any) => y.item1);
      this.pieChartDatasets = [{
        data: x.donationDetailsGroup.map((y: any) => y.item2)
      }];
      if (x.donationsLineChart) {
        this.lineChartLabels = x.donationsLineChart.map((y: any) => y.item2);
        this.lineChartDatasets = [{
          label: 'שיחות',
          data: x.donationsLineChart.map((y: any) => y.item3),
          fill: false,
          backgroundColor: '#007bff',
          tension: 0.1
        }];
      }
      if (x.donationsAmountLineChart) {
        this.amountsLineChartLabels = x.donationsAmountLineChart.map((y: any) => y.item2);
        this.amountsLineChartDatasets = [{
          label: 'סכום',
          data: x.donationsAmountLineChart.map((y: any) => y.item3),
          fill: false,
          backgroundColor: '#28a745',
          tension: 0.1
        }];
      }
    });
  }

  initCenteralForm() {
    let fd = new Date();
    fd.setDate(fd.getDate() - 6);
    let td = new Date();

    this.centeralForm = this.formBuilder.group({
      contactID: [],
      contactName: [],
      relevantDateRange: [new DateRangeClass(fd, td)],
      statusPayment: [],
      commitmentSubject: [],
      commitmentReasonID: [],
      accountLocation: [],
      designation: [],
      designationDetails: [],
      donationCategoryID: [],
      donationCategoryTitle: [],
      currency: [],
    });

    this.centeralForm.controls['commitmentSubject'].valueChanges.subscribe(x => {
      this.servicesData.getList(`CommitmentReasons/${x}`)
        .subscribe(
          (r: any) => {
            this.subjectCommitmentReasons = r;
          },
          error => { });
    });
  }

  setPriod(days: number) {
    let fd = new Date();
    fd.setDate(fd.getDate() - days);
    let td = new Date();

    let dr = new DateRangeClass();
    dr.start = fd;
    dr.end = td;

    this.releventDateRangeCom.startInput.dateControl.setValue(fd);
    this.releventDateRangeCom.endInput.dateControl.setValue(td);
    this.releventDateRangeCom.startInput.dt = fd;
    this.releventDateRangeCom.endInput.dt = td;
    this.releventDateRangeCom.startInput.ngAfterViewInit();
    this.releventDateRangeCom.endInput.ngAfterViewInit();

    this.centeralForm.controls['relevantDateRange'].setValue(dr);
    this.loadCenteralData();
  }

  clerFilter() {
    this.centeralForm.reset();
    this.initCenteralForm();
    this.loadCenteralData();
  }
}
